import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

const CountdownRenderer = ({ entryDate, hoursLimit }) => {
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        if (!entryDate || !hoursLimit || isNaN(hoursLimit)) {
            setTimeLeft(null);
            return;
        }

        const calculateTimeLeft = () => {
            // Force interpretation as Guatemala Timezone to avoid local browser offset issues
            // This handles both offset-naive string (treated as local Guate time) 
            // and aware strings (converted to Guate time).
            const entry = moment.tz(entryDate, "America/Guatemala");

            // Sanitize hoursLimit to prevent negative or zero breaking the countdown
            let parsedLimit = parseFloat(hoursLimit);
            if (isNaN(parsedLimit) || parsedLimit <= 0) {
                parsedLimit = 24; // Default safe fallback
            }

            // Calculate expiration based on hours limit
            const expiration = entry.clone().add(parsedLimit, 'hours');

            // Compare with current time in the same timezone context (though moment handles optimization internally)
            const now = moment();
            const diff = expiration.diff(now);

            if (diff <= 0) {
                return "Tiempo Expirado";
            }

            const duration = moment.duration(diff);
            const hours = Math.floor(duration.asHours());
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            return `${hours}h ${minutes}m ${seconds}s`;
        };

        // Initial set
        const result = calculateTimeLeft();
        setTimeLeft(result);

        // If expired, no need to interval
        if (result === "Tiempo Expirado") return;

        const timer = setInterval(() => {
            const newResult = calculateTimeLeft();
            setTimeLeft(newResult);
            if (newResult === "Tiempo Expirado") clearInterval(timer);
        }, 1000);

        return () => clearInterval(timer);
    }, [entryDate, hoursLimit]);

    if (!timeLeft) return <span className="text-muted">-</span>;

    return (
        <span className={`font-weight-bold ${timeLeft === "Tiempo Expirado" ? "text-danger" : "text-primary"}`}>
            {timeLeft}
        </span>
    );
};

export default CountdownRenderer;
